import { connect } from "react-redux";

import { ViewRequestForm } from "./ViewRequestForm";
import { updateDocumentRequest } from "../../actions/companyActions";
import { showToast } from "utils/helpers";

export const ViewRequestModalComponent = ({
	companyId,
	accessRequest,
	onSuccessfulSubmit,
	updateDocumentRequest,
	...props
}) => {
	const handleSubmit = async (values, { setErrors }) => {
		try {
			await updateDocumentRequest(companyId, values);
			onSuccessfulSubmit(); //closeModal
			if (values.is_approved === 0) {
				showToast("Document Access Declined.", "Success", true);
			} else {
				showToast("Document Access Approved.", "Success", true);
			}
		} catch (e) {
			const error = e.response.json();
			setErrors(error.errors);
			showToast(error.message, "Error");
		}
	};

	return (
		<ViewRequestForm
			accessRequest={accessRequest}
			handleSubmit={handleSubmit}
			title="Request for Document Access"
		/>
	);
};

const mapStateToProps = (state) => {
	const companyId = state.search.activeCompany.id;

	return {
		companyId: companyId,
	};
};

export const ViewRequestModal = connect(mapStateToProps, {
	updateDocumentRequest,
})(ViewRequestModalComponent);
